<template>
  <section :class="[theme.section, sectionClass]">
    <div :class="[theme.container, containerClass]">
      <component
        v-for="(block, idx) in blocks"
        :key="idx"
        :is="block.component"
        v-bind="block.props || {}"
      />
    </div>
  </section>
</template>

<script setup>
import { sectionBlockTheme } from './scripts/themeHelpers';


const props = defineProps({
  blocks: { type: Array, default: () => [] },
  variant: { type: String, default: 'default' },
  sectionClass: { type: String, default: '' },
  containerClass: { type: String, default: '' },
})

const theme = sectionBlockTheme(props.variant)
</script>

<style scoped>
/* Styles génériques si nécessaire */
</style>
